import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, RouteProps } from 'react-router';
import { Helmet } from 'react-helmet';
import Immutable from 'immutable';

import { entityReset } from '@uncinc/react-drupal-core';
import type { Langcodes } from '@uncinc/react-drupal-core/types';

import { DEFAULT_LANGUAGE } from '../../config/constants';
import useTypedDispatch from '../../helpers/useDispatch';

const CustomRoute: React.FC<RouteProps> = (props) => {
  const language = useSelector<Immutable.Map<string, any>>(
    (state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE),
  ) as Langcodes;
  const dispatch = useTypedDispatch();

  // We may have done a request to translate-path for the current route.
  // Reset the entity to prevent a possible 404 page flash.
  useEffect(() => () => {
    dispatch(entityReset());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <html lang={language} />
      </Helmet>
      <Route {...props} />
    </>
  );
};

export default CustomRoute;
